
import { defineComponent, onMounted } from 'vue';
import CardListing from '@/components/CardListing.vue'
import Loading from '@/components/Loading.vue'
import Pagination from '@/components/Pagination.vue'
import { state } from '@/util/job'
import { useRouter } from 'vue-router';

export default defineComponent({
  name: 'Home',
  components: {
    CardListing,
    Pagination,
    Loading
  },
  setup() {
    const router = useRouter()
    const searchFunction = () => {
      state.getData(state.searchTerm, state.searchFullTime, state.searchLocation)
    }
    onMounted( async () => {
      state.searchTerm || state.searchFullTime || state.searchLocation || state.joblist.length ? '' : await state.getData('code')
    })

    return {
      state,
      router,
      searchFunction
    }
  }
});
